import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { mapState, mapActions, mapGetters } from 'vuex';
import { isEmpty } from 'lodash';
export default {
  data: function data() {
    return {
      qnToken: '',
      uploadData: {
        data: {
          token: '',
          key: ''
        },
        accept: '.png,.jpeg,.jpg',
        class: 'avatar-uploader',
        action: 'https://up-z2.qiniup.com',
        'show-file-list': false,
        multiple: false
      }
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters('d2admin', {
    routeKeyArr: 'permission/routeKeyArr'
  })), mapState('d2admin', {
    dict: function dict(state) {
      return state.dict;
    },
    isLogged: function isLogged(state) {
      return state.account.isLogged;
    }
  })), {}, {
    VUE_APP_IMG_BASE: function VUE_APP_IMG_BASE() {
      return process.env.VUE_APP_IMG_BASE;
    },
    VUE_APP_TITLE: function VUE_APP_TITLE() {
      return process.env.VUE_APP_TITLE;
    },
    VUE_APP_ICON_IMG: function VUE_APP_ICON_IMG() {
      return process.env.VUE_APP_ICON_IMG;
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapActions({
    isImShowSet: 'd2admin/message/isImShow',
    isImFormIdSet: 'd2admin/message/isImFormId'
  })), {}, {
    openImageView: function openImageView(link) {
      // 打开图片预览
      this.$hevueImgPreview(link);
    },
    isShowAuto: function isShowAuto(key) {
      return this.routeKeyArr.includes(key);
    },
    tximLogin: function tximLogin(sign) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", YL.txim._p( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(next) {
                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _context2.next = 2;
                            return YL.txim.login(sign, /*#__PURE__*/function () {
                              var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(res) {
                                return regeneratorRuntime.wrap(function _callee$(_context) {
                                  while (1) {
                                    switch (_context.prev = _context.next) {
                                      case 0:
                                        if (!(res.data.repeatLogin === true)) {
                                          _context.next = 6;
                                          break;
                                        }

                                        _context.next = 3;
                                        return YL.txim.logout();

                                      case 3:
                                        _context.next = 5;
                                        return _this.tximLogin(sign);

                                      case 5:
                                        next();

                                      case 6:
                                      case "end":
                                        return _context.stop();
                                    }
                                  }
                                }, _callee);
                              }));

                              return function (_x2) {
                                return _ref2.apply(this, arguments);
                              };
                            }());

                          case 2:
                            next();

                          case 3:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }()));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    getUserSig: function getUserSig() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!_this2.isLogged) {
                  _context4.next = 10;
                  break;
                }

                _context4.next = 3;
                return _this2.$api.imUserSign();

              case 3:
                res = _context4.sent;

                if (!isEmpty(res.userId)) {
                  _context4.next = 6;
                  break;
                }

                return _context4.abrupt("return");

              case 6:
                _context4.next = 8;
                return YL.txim.setAdminId(res.userId);

              case 8:
                _context4.next = 10;
                return _this2.tximLogin(res.sign);

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    isBtnGroud: function isBtnGroud(status, auto) {
      return status.includes(auto);
    },
    //异步等待确认
    isLoaded: function isLoaded(oped, callback) {
      if (oped) return Promise.resolve(callback && callback());
      return new Promise(function (resolve) {
        var timer = setInterval(function () {
          resolve(clearInterval(timer));
        }, 10);
      });
    },
    getUsig: function getUsig() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this3.$api.imUserSign();

              case 2:
                res = _context5.sent;
                return _context5.abrupt("return", res);

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    goReplace: function goReplace(name, query) {
      this.$router.replace({
        name: name,
        query: query
      });
    },
    goRoute: function goRoute(name, query) {
      this.$router.push({
        name: name,
        query: query
      });
    },
    redirectTo: function redirectTo(path) {
      var currentPage = this.$store.state.d2admin.page.current;
      this.$store.dispatch('d2admin/page/close', {
        tagName: currentPage
      });
      this.$router.push(path);
    },
    goBack: function goBack() {
      var currentPage = this.$store.state.d2admin.page.current;
      console.log('goBack', currentPage);
      this.$store.dispatch('d2admin/page/close', {
        tagName: currentPage
      });
      this.$router.back();
    },
    transformDateFormat: function transformDateFormat() {
      var _YL;

      return (_YL = YL).dateFormat.apply(_YL, arguments);
    },
    getQiNiu: function getQiNiu() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var _yield$_this4$$api$ge, token;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return _this4.$api.getUploadToken();

              case 2:
                _yield$_this4$$api$ge = _context6.sent;
                token = _yield$_this4$$api$ge.token;
                _this4.qnToken = token;
                _this4.uploadData.data.token = token;

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    copyText: function copyText(e) {
      YL.copyThat(e);
    },
    // 格式转换
    formatJson: function formatJson(filterVal, jsonData) {
      var _this5 = this;

      return jsonData.map(function (v) {
        return filterVal.map(function (j) {
          if (j == 'orderStatus') {
            v[j] = _this5.statusFn(v[j]);
          }

          return v[j];
        });
      });
    },
    xlsxExport: function xlsxExport(columns, data) {
      var _this6 = this;

      var title = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Date().getTime();
      this.$confirm('确定下载列表文件?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this6.xlsxColumns = [];

        _this6.$export.excel({
          title: _this6.VUE_APP_TITLE + title,
          columns: columns,
          data: data
        });
      });
    },
    webPrint: function webPrint() {
      var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var iframe = document.createElement('IFRAME');
      var doc = null;
      iframe.setAttribute('style', 'position:absolute; height:0;left:-5000000px;top:-500000px;');
      document.body.appendChild(iframe);
      doc = iframe.contentWindow.document;
      doc.write(str);
      doc.close();
      setTimeout(function () {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();

        if (navigator.userAgent.indexOf('MSIE') > 0) {
          document.body.removeChild(iframe);
        }
      }, 0);
    },
    printComp: function printComp(param) {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var arr, addKey, handlePrint, str, n, i, element;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                arr = [];
                addKey = ['consigneeProvince', 'consigneeCity', 'consigneeDistrict', 'consigneeDetails'];
                param.forEach(function (row) {
                  var _row$consigneeInfo, _row$consigneeInfo2;

                  var parasm = {
                    id: row.orderNo,
                    price: Number(row.orderAmount).toFixed(2),
                    date: row.orderTime,
                    name: ((_row$consigneeInfo = row.consigneeInfo) === null || _row$consigneeInfo === void 0 ? void 0 : _row$consigneeInfo.consigneeName) || '-',
                    phone: ((_row$consigneeInfo2 = row.consigneeInfo) === null || _row$consigneeInfo2 === void 0 ? void 0 : _row$consigneeInfo2.consigneePhone) || '-',
                    address: Object.keys(row.consigneeInfo).map(function (v) {
                      return addKey.includes(v) ? row.consigneeInfo[v] : false;
                    }).filter(function (v) {
                      return v;
                    }).join(' '),
                    isPois: row.invoiceType,
                    remoke: row.buyerRemark,
                    store_remoke: row.storeRemark,
                    list: row.goodsItemList.map(function (x) {
                      return {
                        id: x.goodsNo,
                        name: x.goodsName,
                        attr: x.itemSellAttributes.map(function (v) {
                          return v.itemValue;
                        }).join(','),
                        count: x.goodsCount,
                        price: x.goodsPrice,
                        all: x.subtotalAmount
                      };
                    })
                  };
                  arr.push(parasm);
                });
                handlePrint = _this7.$refs.refPintComp.handlePrint;
                str = [];
                n = arr.length;
                i = 0;

              case 7:
                if (!(i < arr.length)) {
                  _context7.next = 19;
                  break;
                }

                element = arr[i];
                _context7.t0 = str;
                _context7.next = 12;
                return handlePrint(element, arr.length);

              case 12:
                _context7.t1 = _context7.sent;

                _context7.t0.push.call(_context7.t0, _context7.t1);

                n--;

                if (n == 0) {
                  console.log(str);

                  _this7.webPrint(str.join(''));
                }

              case 16:
                i++;
                _context7.next = 7;
                break;

              case 19:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    }
  })
};